import React, { PureComponent } from "react";
import { connect } from "react-redux";

import * as styles from './style.css';
import { authByFacebookSigningSelector } from "../../../store/auth-by-facebook/selectors";
import { authByGoogleSigningSelector } from "../../../store/auth-by-google/selectors";
import { loginByFacebook } from "../../../store/auth-by-facebook/actions";
import { loginByGoogle } from "../../../store/auth-by-google/actions";
// import Icon from "app/modules/custom-icons";
import UQButton from "../../../../uq-ui/components/button";
import Icon from "../../../../icons/Icon";
import { isMemorialType } from "../../../../stickers/store/sticker-show/selectors";

class AuthComponentsAuthSocial extends PureComponent {

  loginByEmail = () => {
    this.props.history.push('/login/email');
  }

  render() {
    return (
      <div className={styles.container}>
        <UQButton
          label="Google"
          icon={<Icon name="SocGoogle" width="26px" height="26px"  />}
          theme={ this.props.isMemorialTheme ? 'whiteDarkText' : 'white' }
          containerClass={styles.btn}
          onPress={this.props.loginByGoogle}/>
        <UQButton
          label="Email"
          icon={<Icon name="SocEmail" width="26px" height="26px"  />}
          containerClass={styles.btn}
          theme={ this.props.isMemorialTheme ? 'whiteDarkText' : 'white' }
          onPress={this.loginByEmail}/>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isFacebookSigning: authByFacebookSigningSelector(state),
    isGoogleSigning: authByGoogleSigningSelector(state),
    isMemorialTheme: isMemorialType(state),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    loginByFacebook: () => dispatch(loginByFacebook()),
    loginByGoogle: () => dispatch(loginByGoogle())
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthComponentsAuthSocial);


// WEBPACK FOOTER //
// ./src/app/modules/auth/ui/components/auth-social/index.jsx